import { createFileRoute } from '@tanstack/react-router'
import { EnterpriseBatchPage, enterpriseBatchSearchSchema } from '@/features/service-enterprise/index.ts'

export const Route = createFileRoute('/_authenticated/customer-management/subjects_/materials/batch')({
  validateSearch: enterpriseBatchSearchSchema,
  component: Page,
  head: () => ({ meta: [{ title: '批量补录服务对象资料 · Super Mega' }] })
})
function Page() {
  const { ids } = Route.useSearch()
  return <EnterpriseBatchPage key={ids.join(':')} ids={ids} />
}
